












































import { Component, Vue, Prop } from "vue-property-decorator";
import { WowClass } from "./../types/WowClass";
import prismicDOM from 'prismic-dom';

@Component({
  mounted() {
    this.$store.dispatch("loadClass", this.$route.params.uid);
  }
})
export default class ClassDetail extends Vue {
  get wowClass() {
    return this.$store.state.class;
  }

  get desc() {
    return prismicDOM.RichText.asHtml(this.wowClass.description);
  }
}
